import { Switch, Route, Redirect } from "react-router-dom";

import LoginWrapper from "../login";
import { SIP3W } from "../sip3w";
import { FormSolicitacaoAcesso } from "../formSolicitacaoAcesso";

import { FormEstagio } from "../formEstagio";

import { FormApprovalHigher } from "../formApprovalHigher";
import Home from "../home";
import { Sip3wFormApproval } from "../sip3w/formApproval";

import { Dip } from "../inteligenciaDip";
import { InteligenciaDipFormApproval } from "../inteligenciaDip/formApproval";

import { InteligenciaAsintList } from "../inteligenciaAsint";
import { InteligenciaAsintFormApproval } from "../inteligenciaAsint/formApproval";

import { InteligenciaAssintList } from "../inteligenciaAssint";
import { InteligenciaAssintFormApproval } from "../inteligenciaAssint/formApproval";

import { InteligenciaCoinList } from "../inteligenciaCoin";
import { InteligenciaCoinFormApproval } from "../inteligenciaCoin/formApproval";

import { SecretarioExecutivoList } from "../secretarioExecutivo";
import { SecretarioExecutivoFormApproval } from "../secretarioExecutivo/formApproval";

import { CoticList } from "../cotic";
import { CoticFormApproval } from "../cotic/formApproval";

import { UserView } from "../userView";

import { useAuth } from "../../hooks/auth";

import { EstagioBusca } from "../estagioBusca";
import { DetalhesEstagio } from "../estagioBusca/estagioDetalhes";

import { ConsultaPorCPF } from "../consultaPorCpf";

import { useCallback } from "react";
import ViewFichaCompleta from "../../components/viewFIchaCompleta";

import { Auditoria } from "../auditoria";
export default function Routes() {
  const { token, roles } = useAuth();

  const isPermitted = useCallback(
    (role) => {
      const data = (roles || []).filter(
        (value) =>
          value.toLocaleUpperCase() === `ROLE_SSA_${role.toLocaleUpperCase()}`
      );
      return data.length > 0;
    },
    [roles]
  );

  return (
    <Switch>
      {token && isPermitted("ESTAGIO") && (
        <Route path="/estagios" exact component={EstagioBusca} />
      )}
      {token && isPermitted("ESTAGIO") && (
        <Route
          path="/detalhesEstagio/:estagiario"
          exact
          component={DetalhesEstagio}
        />
      )}

      {!token && <Route path="/login" exact component={LoginWrapper} />}

      {token && <Route path="/home" exact component={Home} />}

      {token && <Route path="/cotic" exact component={CoticList} />}
      {token && <Route path="/cotic/:id" exact component={CoticFormApproval} />}

      {token && isPermitted("SIP3W") && (
        <Route path="/sip3w" exact component={SIP3W} />
      )}
      {token && isPermitted("SIP3W") && (
        <Route path="/sip3w/:id" exact component={Sip3wFormApproval} />
      )}

      {token && isPermitted("INTELIGENCIA_DIP") && (
        <Route path="/dip" exact component={Dip} />
      )}
      {token && isPermitted("INTELIGENCIA_DIP") && (
        <Route path="/dip/:id" exact component={InteligenciaDipFormApproval} />
      )}

      {token && isPermitted("INTELIGENCIA_ASINT") && (
        <Route path="/asint" exact component={InteligenciaAsintList} />
      )}
      {token && isPermitted("INTELIGENCIA_ASINT") && (
        <Route
          path="/asint/:id"
          exact
          component={InteligenciaAsintFormApproval}
        />
      )}

      {token && isPermitted("INTELIGENCIA_ASSINT") && (
        <Route path="/assint" exact component={InteligenciaAssintList} />
      )}
      {token && isPermitted("INTELIGENCIA_ASSINT") && (
        <Route
          path="/assint/:id"
          exact
          component={InteligenciaAssintFormApproval}
        />
      )}

      {token && isPermitted("INTELIGENCIA_COIN") && (
        <Route path="/coin" exact component={InteligenciaCoinList} />
      )}
      {token && isPermitted("INTELIGENCIA_COIN") && (
        <Route
          path="/coin/:id"
          exact
          component={InteligenciaCoinFormApproval}
        />
      )}

      {token && isPermitted("EXECUTIVO") && (
        <Route path="/secretario" exact component={SecretarioExecutivoList} />
      )}
      {token && isPermitted("EXECUTIVO") && (
        <Route
          path="/secretario/:id"
          exact
          component={SecretarioExecutivoFormApproval}
        />
      )}

      {token && isPermitted("COTIC") && (
        <Route path="/cotic" exact component={CoticList} />
      )}
      {token && isPermitted("COTIC") && (
        <Route path="/cotic/:id" exact component={CoticFormApproval} />
      )}

      {token && isPermitted("COTIC") && (
        <Route path="/user/cpf" exact component={ConsultaPorCPF} />
      )}

      {token && isPermitted("COTIC") && (
        <Route path="/ficha/:id" exact component={ViewFichaCompleta} />
      )}

      <Route path="/user/:id" exact component={UserView} />

      {token && isPermitted("AUDITORIA") && (
        <Route path="/auditoria" exact component={Auditoria} />
      )}

      <Route path="/solicitacao" exact component={FormSolicitacaoAcesso} />
      <Route path="/estagio" exact component={FormEstagio} />
      <Route path="/approvalHigher/:id" exact component={FormApprovalHigher} />

      {!token && <Redirect to="/login" />}
      {token && <Redirect to="/home" />}
    </Switch>
  );
}
